import React from 'react';

import { css, StyleSheet } from 'aphrodite';

import Container from 'components/shared/Container';
import DashboardWidgetTile from 'components/dashboard/DashboardWidgetTile';
import DashboardWidgetType, {
  DashboardWidgetTypeLabels,
  WidgetClickHandlers,
} from 'lib/enums/DashboardWidgetTypes';
import { squidInk } from 'lib/css/colors';

// Every brand falls into exactly one of these, and all four are counted against the same
// total, so the percentages add up to 100%
const WIDGET_TYPES = [
  DashboardWidgetType.VERIFIED_BRANDS,
  DashboardWidgetType.UNVERIFIED_BRANDS,
  DashboardWidgetType.VERIFICATION_PENDING_BRANDS,
  DashboardWidgetType.UNVERIFIABLE_BRANDS,
];

function BrandVerificationStatsSection() {
  return (
    <Container className={css(styles.section)}>
      <h2 className={css(styles.title)}>Brand Verification</h2>
      <div className={css(styles.grid)}>
        {WIDGET_TYPES.map(widgetType => (
          <DashboardWidgetTile
            key={widgetType}
            widgetType={widgetType}
            label={DashboardWidgetTypeLabels[widgetType]}
            onClick={WidgetClickHandlers[widgetType]}
          />
        ))}
      </div>
    </Container>
  );
}

const styles = StyleSheet.create({
  section: {
    padding: '20px',
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    color: squidInk,
    marginBottom: 16,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
    gap: 20,
  },
});

export default BrandVerificationStatsSection;
